<template>
    <!-- Feature Section start -->
    <section id="feature" class="feature">
        <div class="feature-decor">
            <div class="feature-circle1">
                <img :src="'../assets/images/feature2.png'" alt>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-sm-8 offset-sm-3 mrgn-md-top">
                            <h2 class="title">
                                Our popular
                                <span>Games</span>
                            </h2>
                        </div>
                        <div class="col-12">
                            <ul class="feature-style">
                                <li>
                                    <div class="row">
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://images-na.ssl-images-amazon.com/images/I/61XeI1DX8lL._SL210_QL95_BG0,0,0,0_FMpng_.png"
                                                alt="icon"
                                            >
                                        </div>
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Escape the Room <AlexaLink source="homepage" game="EscapeTheRoom" /></h3>
                                            </div>
                                            <div>
                                                <p>
                                                    The original Alexa based Escape Room. Grab your family and friends and attempt to escape from 4 different rooms of ranging in difficulty. Make a fast escape and see how your time compares to the millions of other players. Walkthroughs:&nbsp
                                                    <router-link to="/walkthrough/office">The Office</router-link>-
                                                    <router-link to="/walkthrough/car">The Car</router-link>-
                                                    <router-link
                                                        to="/walkthrough/jailcell"
                                                    >The Jail Cell</router-link>-
                                                    <router-link to="/walkthrough/garage">The Garage</router-link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="row">
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Escape the Room 2 <AlexaLink source="homepage" game="EscapeTheRoom2" /></h3>
                                            </div>
                                            <div>
                                                <p>A Sequel to Escape the Room with three new rooms! The Hospital, The Zoo, and The Spaceship. No Walkthroughs for these ones yet, try them out on your own or as for hints in-game.</p>
                                            </div>
                                        </div>
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://images-na.ssl-images-amazon.com/images/I/718hXOqaZGL.png"
                                                alt="icon"
                                            >
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="row">
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://m.media-amazon.com/images/I/51wQSMB69dL.png"
                                                alt="icon"
                                            >
                                        </div>
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Puzzle of the Day <AlexaLink source="homepage" game="PuzzleOfTheDay" /></h3>
                                            </div>
                                            <div>
                                                <p>
                                                    Puzzle of the Day is our take on a Daily Crossword puzzle, designed specifically for Alexa. Keep your skills sharp by coming back each day to tackle the daily puzzle.
                                                    <a
                                                        href="https://www.stokedskills.com/puzzleoftheday"
                                                    >See the Leaderboards</a>
                                                    or
                                                    <a
                                                        href="https://www.stokedskills.com/puzzleoftheday/submityourown"
                                                    >Submit a user generated puzzle</a>!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="row">
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Angel Investor <AlexaLink source="homepage" game="AngelInvestor" /></h3>
                                            </div>
                                            <div>
                                                <p>
                                                    You quit your job and decided to make the leap into Angel Investing. Start from the bottom and invest in great startups to build your venture capitalist empire!
                                                    <a
                                                        href="https://www.stokedskills.com/angelinvestor"
                                                    >Leaderboards</a>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://images-na.ssl-images-amazon.com/images/I/61U9MHAcWtL._SL210_QL95_BG0,0,0,0_FMpng_.png"
                                                alt="icon"
                                            >
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="row">
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://images-na.ssl-images-amazon.com/images/I/61LkqD4onML.png"
                                                alt="icon"
                                            >
                                        </div>
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Game of Words <AlexaLink source="homepage" game="GameOfWords" /></h3>
                                            </div>
                                            <div>
                                                <p>
                                                    A real time multiplayer word game, medieval style. Starting as a mere peasant, rise through the ranks to become a Royal Emperor of your kingdom while competing against others around the world.
                                                    <a
                                                        href="https://www.stokedskills.com/gameofwords"
                                                    >Check out the rankings!</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="row">
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Christmas Escape <AlexaLink source="homepage" game="ChristmasEscape" /></h3>
                                            </div>
                                            <div>
                                                <p>
                                                    It's Christmas Eve and you've found yourself trapped in a home. Will you be able to escape on time to deliver your presents and save Christmas?
                                                    <a
                                                        href="https://www.amazon.com/Stoked-Skills-LLC-Christmas-Escape/dp/B07MGKGV8Z"
                                                    >Play Now</a>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://images-na.ssl-images-amazon.com/images/I/51cCnBibBtL._SL210_QL95_BG0,0,0,0_FMpng_.png"
                                                alt="icon"
                                            >
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="row">
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://images-na.ssl-images-amazon.com/images/I/51ncTQvNz9L._SL210_QL95_BG0,0,0,0_FMpng_.png"
                                                alt="icon"
                                            >
                                        </div>
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Word Play <AlexaLink source="homepage" game="WordPlay" /></h3>
                                            </div>
                                            <div>
                                                <p>
                                                    Play against your friends or make your way up the leaderboards in this fun word game that will make you think hard!
                                                    <a
                                                        href="https://www.stokedskills.com/wordplay/leaderboard.html"
                                                    >Check out the Leaderboards</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="row">
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Escape the Airplane <AlexaLink source="homepage" game="EscapeTheAirplane" /></h3>
                                            </div>
                                            <div>
                                                <p>
                                                    Our hardest Escape Room series - A three part escape room adventure taking place thousands of feet in the air! Will you make it out alive?
                                                    <a
                                                        href="https://www.amazon.com/Stoked-Skills-LLC-Escape-Airplane/dp/B07CMB6DZQ"
                                                    >Try it Now</a>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://images-na.ssl-images-amazon.com/images/I/71VTgiEEI0L._SL210_QL95_BG0,0,0,0_FMpng_.png"
                                                alt="icon"
                                            >
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="row">
                                        <div class="col-2 feature-icon">
                                            <img
                                                src="https://images-na.ssl-images-amazon.com/images/I/51iCkp6foPL._SL210_QL95_BG0,0,0,0_FMpng_.png"
                                                alt="icon"
                                            >
                                        </div>
                                        <div class="col-sm-10 col-12 feature-text">
                                            <div class="feature-subtitle">
                                                <h3>Word Wiz <AlexaLink source="homepage" game="WordWiz" /></h3>
                                            </div>
                                            <div>
                                                <p>
                                                    A real-time online multiplayer word-game on Alexa. Find the most words and compete against players around the world in real time in this engaging word puzzle game.
                                                    <a
                                                        href="https://www.stokedskills.com/wordwiz"
                                                    >See the Leaderboards</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Feature Section End -->
</template>
<script>
import AlexaLink from "@/components/AlexaLink.vue";

export default {
    name: "feature",
    components: { AlexaLink }
};
</script>

<style scoped>
@media (max-width: 992px) {
    .feature-icon img {
        width: 100px !important;
        height: 100px !important;
    }
}
@media (max-width: 576px) {
    .feature-icon img {
        position: absolute;
        width: 35px !important;
        height: 35px !important;
        top: -10px;
    }
    .feature-icon {
        order: 1;
    }
    .feature-text {
        order: 2;
    }
    .feature-subtitle {
        padding-left: 40px;
    }
}
.feature-icon img {
    width: 150px;
    height: 150px;
}
.feature-subtitle {
    font-weight: bold;
}
.feature-style {
    padding-top: 100px;
    padding-bottom: 50px;
}
.feature {
    background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/feature.vue